import { Box} from '@material-ui/core'
import React, { useContext } from 'react'
import { SwiperSlide,Swiper } from 'swiper/react'
import { Pagination, Navigation } from "swiper";
import { ProductContext } from '../Context/ProductProvider';
import TScard from '../SmallComponents/TScard';




const Gaming = () => {
    const {state:{product}} = useContext(ProductContext)

    const gaming = product.filter((e)=>{
        return e.highlight === 'gaming'
    })
  return (
    <Box style={{background: 'black', paddingTop: '5rem', paddingBottom: '5rem' }} >
        <Box style={{ maxWidth: '75vw', typography: 'body1', margin: 'auto', position: 'relative', left: '1rem'}}>
            <h1  style={{paddingBottom: '5rem', color: 'white'}}> Gaming </h1>
            
              
{/* -------------------------------------------------------------------------------- */}
                {/* =========TAB 1============= */}
              
                <Box style={{width: '75vw',}}>
                  <Swiper
                      slidesPerView={4}
                      spaceBetween={30}
                      slidesPerGroup={4}
                      loop={false}
                      loopFillGroupWithBlank={true}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      modules={[Pagination, Navigation]}
                      breakpoints={
                        {
                            320: {
                              slidesPerView: 1,
                              slidesPerGroup: 1,
                              spaceBetween: 100
                            },
                            500: {
                              slidesPerView: 2,
                              slidesPerGroup: 2,
                              spaceBetween: 20
                            },
                            900: {
                              slidesPerView: 3,
                              slidesPerGroup: 3,
                              spaceBetween: 20
                            },
                            1100:{
                              slidesPerView: 4,
                            slidesPerGroup: 4,
                            spaceBetween: 20
                          }
                        }
                      }
                      >
                        {
                        gaming.map((elm, i)=>{
                              return(
                                <SwiperSlide key={elm.id}>
                                  <TScard name={elm.name} price={elm.price} image={elm.img} id={elm} />
                                </SwiperSlide>
                              )
                          })}
                      </Swiper>
                  </Box>
        </Box>
    </Box>
  )
}

export default Gaming